// Libraries
import lib from "./js-lib/lib.js";

import frm_section1 from "./Modal/frm_section1";
import frm_section2 from "./Modal/frm_section2";

/* Manage State */
window.state = {
  peopleList: [],
  dataPeopleList: [["", "", ""]],
  piList: [],
  datapiGroupList: [["Project", "", "", [["", "Null"]]]],
};

window.App = {
  load_cache: (data = false) => {},
  global_scope: (data = false) => {},
  scope: (data = false) => {
    frm_section1.scope();
    frm_section2.scope();
  },
  postScope: () => {},

  restResponse: (data) => {},
  render: (data = false) => {
    frm_section1.render();
    frm_section2.render();
  },
};

// Wait for the DOM to load
window.onload = function () {
  App.load_cache();
  App.global_scope();
  App.scope();
  App.render();
};
